export enum PAYMENT_COMPS {
  TRANSPORTATION = 'TRANSPORTATION',
  SELECT_ORDERS = 'SELECT_ORDERS',
  FINAL_FACTOR = 'FINAL_FACTOR',
  DISCOUNT = 'DISCOUNT',
  ENDING = 'ENDING',
}

export const PaymentStepsMap = new Map<number, PAYMENT_COMPS>([
  [2, PAYMENT_COMPS.TRANSPORTATION],
  [1, PAYMENT_COMPS.SELECT_ORDERS],
  [3, PAYMENT_COMPS.FINAL_FACTOR],
  [4, PAYMENT_COMPS.ENDING],
]);

function* repeat(iterableSupplier: () => IterableIterator<PAYMENT_COMPS>) {
  while (true) yield* iterableSupplier();
}

export const PaymentStepsGenerator = () =>
  repeat(() => PaymentStepsMap.values());

export enum PaymentStatus {
  Implementation = 3322,
  Canceled = 3338,
  NotDone = 3300,
  Payment = 3330,
  Sent = 3333,
  Done = 3323,
}

export const PaymentErrors = {
  NOT_PROCESSABLE: 'غیر قابل انجام',
  INFORMATION_FALSY: 'مشکل اطلاعات',
  FILE_BROKEN: 'مشکل فایل',
};

export const PaymentErrorsArray = [
  'INFORMATION_FALSY',
  'NOT_PROCESSABLE',
  'FILE_BROKEN',
] as const;

export const PaymentPersianErrorsTypeArray = [
  'غیر قابل انجام',
  'مشکل اطلاعات',
  'مشکل فایل',
];
